import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';
import { logError } from 'lib/sentry/logError';

import { IPlanningSprint, PlanningSprintModel } from 'features/planning';
import { useUserId } from 'features/user/hooks/useUserId';

export const useSprintsQuery = <T>(
  options: { enabled?: boolean } = {
    enabled: true,
  }
) => {
  const { request } = useQueryHTTPRequest();
  const userId = useUserId();

  return useQuery<{ sprints: IPlanningSprint[] }, unknown, T>(
    [queryKeys.sprints, userId],
    ({ signal }) =>
      request({
        url: `/api/sprint-planning/sprints?user_id=${userId}`,
        signal,
      }),
    {
      enabled: !!userId && options.enabled,
      // @ts-ignore
      select,
      staleTime: 1000 * 20,
      onError: (error) => {
        logError(error);
      },
    }
  );
};

const select = (data: { sprints: IPlanningSprint[] }) =>
  data.sprints.map((sprint) => new PlanningSprintModel(sprint));
